import { Box, Text } from '@chakra-ui/react';

export const GridPreview = () => {
  return (
    <Box>
      <Text>GridPreview - Coming soon</Text>
    </Box>
  );
};
